import { render, staticRenderFns } from "./rego-customer-confirm-phone-number.vue?vue&type=template&id=0411215d&scoped=true&"
import script from "./rego-customer-confirm-phone-number.vue?vue&type=script&lang=js&"
export * from "./rego-customer-confirm-phone-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0411215d",
  null
  
)

export default component.exports